import { useDispatch, useSelector } from 'react-redux';
import { updateVoucher } from '../../reducers/voucher';
import { updateSubscription } from '../../reducers/subscription';
import api from '../../services/api';
import Numeral from '../numeral';
import { StyledVoucherField, StyledRemoveVoucherLink } from './style';
import { Input } from '../input';
import { Button, } from '../button';

const Voucher = () => {
  const dispatch = useDispatch();

  const subscription = useSelector((state) => state.subscription);

  const handleRemoveVoucherClick = () => {
    dispatch(updateVoucher(''));
    dispatch(updateSubscription({
      discountPrice: 0,
      voucher: '',
    }));

    api.post('/subscriptions/remove-voucher')
  }

  const handleClick = () => {
    let voucherCode = document.getElementById('voucher').value;

    if(voucherCode){
      api.post('/subscriptions/add-voucher', {
        voucher_code: voucherCode
      }).then((response) => {
        if(response.data.voucher){
          dispatch(updateVoucher(response.data.voucher));
          dispatch(updateSubscription({
            discountPrice: response.data.voucher.value,
            voucher: response.data.voucher.code,
          }));
        }
        else {
          alert('Cupom não encontrado');
        }
      }).catch((response) => {
        alert('Cupom não encontrado');
      });
    }
    else {
      alert('Digite um cupom para continuar');
    }
  }

  const handleKeyPress = (e) => {
    if(e.key === 'Enter'){
      e.preventDefault();

      handleClick();
    }
  }

  if(!subscription.voucher){
    return (
      <StyledVoucherField>
        <Input
          name="voucher"
          className="small"
          onKeyPress={handleKeyPress}
        />
        <Button
          size="small"
          buttonStyle="default"
          onClick={handleClick}
        >
          Aplicar
        </Button>
      </StyledVoucherField>
    )
  }
  else {
    return(
      <>
        <strong>
          <Numeral value={subscription.discountPrice} format="$ 0,0.00" />
        </strong>

        <StyledRemoveVoucherLink onClick={handleRemoveVoucherClick}>
          Editar
        </StyledRemoveVoucherLink>
      </>
    )
  }
}

export default Voucher;
